import IErrorViewer from "@/views/IErrorViewer";

export function instanceOfIErrorViewer(object: any): object is IErrorViewer {
  return "error" in object;
}

export function instanceOfXhrError(object: any): object is Error {
  return "response" in object && "request" in object;
}
